import React from 'react';
import PropTypes from 'prop-types';
import ReactTooltip from 'react-tooltip';
import 'styles/less/components/jsx-tooltip.less';

const Tooltip = ({ id, place, effect }) => {
  return <ReactTooltip id={id} className="jsx-tooltip text-center" place={place} effect={effect} />;
};

Tooltip.propTypes = {
  id: PropTypes.string.isRequired,
  place: PropTypes.oneOf(['bottom', 'left', 'right', 'top']),
  effect: PropTypes.oneOf(['solid', 'float'])
};

Tooltip.defaultProps = {
  place: 'top',
  effect: 'solid'
};

export default Tooltip;



// WEBPACK FOOTER //
// ./src/common/jsx/elements/messages/Tooltip.js